import { render, staticRenderFns } from "./vault-headers.vue?vue&type=template&id=21a6bef3"
import script from "./vault-headers.vue?vue&type=script&lang=js"
export * from "./vault-headers.vue?vue&type=script&lang=js"
import style0 from "./vault-headers.vue?vue&type=style&index=0&id=21a6bef3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports